import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { createLazyRoute } from '../utils/lazyLoading';
import DashboardContent from '../DashboardContent';

// SolMenu - MultiScreenProvider zaten içinde
const SolMenu = createLazyRoute(() => import('../SolMenu'));

/* 13.09.2026: favorilere eski/yanlış önekle kaydedilmiş adresler (/customers/…,
   /work-orders/…) panoya düşüyordu. Önek düzeltilip aynı sayfaya gidilir. */
const OnekDuzelt: React.FC<{ eski: string; yeni: string }> = ({ eski, yeni }) => {
    const { pathname, search } = useLocation();
    return <Navigate to={`${yeni}${pathname.slice(eski.length)}${search}`} replace />;
};

// Lazy load routes
const CustomerRoutes = React.lazy(() => import('./CustomerRoutes'));
const ServiceRoutes = React.lazy(() => import('./ServiceRoutes'));
const StockRoutes = React.lazy(() => import('./StockRoutes'));
const FinanceRoutes = React.lazy(() => import('./FinanceRoutes'));
const PersonnelRoutes = React.lazy(() => import('./PersonnelRoutes'));
const ReportRoutes = React.lazy(() => import('./ReportRoutes'));
const SettingsRoutes = React.lazy(() => import('./SettingsRoutes'));
const CrmRoutes = React.lazy(() => import('./CrmRoutes'));
const InvoiceRoutes = React.lazy(() => import('./InvoiceRoutes'));
const NewCustomer = React.lazy(() => import('../NewCustomer'));
const TransactionsList = React.lazy(() => import('../TransactionsList'));
const PurchaseOrders = React.lazy(() => import('../PurchaseOrders'));
const SalesInvoice = React.lazy(() => import('../SalesInvoice'));
const DebtStatement = React.lazy(() => import('../DebtStatement'));
const ReceivableStatement = React.lazy(() => import('../ReceivableStatement'));
const NewService = React.lazy(() => import('../NewService'));
const SmsPurchase = React.lazy(() => import('../SmsPurchase'));
const SubscriptionPurchase = React.lazy(() => import('../SubscriptionPurchase'));
const Wizard = createLazyRoute(() => import('../Wizard'));
const Uyarilar = React.lazy(() => import('../pages/Uyarilar'));

const MainRoutes: React.FC = () => {
    return (
        // ✅ SolMenu wrapper içinde route'lar - MultiScreenProvider SolMenu'de zaten var!
                <Routes>
                    <Route path="/*" element={<SolMenu />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardContent />} />
                <Route path="wizard" element={<Wizard />} />
                <Route path="customer/*" element={<CustomerRoutes />} />
                <Route path="customers/*" element={<OnekDuzelt eski="/customers" yeni="/customer" />} />
                <Route path="work-orders/*" element={<OnekDuzelt eski="/work-orders" yeni="/service" />} />
                <Route path="service/*" element={<ServiceRoutes />} />
                <Route path="stock/*" element={<StockRoutes />} />
                <Route path="finance/*" element={<FinanceRoutes />} />
                <Route path="personnel/*" element={<PersonnelRoutes />} />
                <Route path="report/*" element={<ReportRoutes />} />
                <Route path="settings/*" element={<SettingsRoutes />} />
                <Route path="crm/*" element={<CrmRoutes />} />
                <Route path="invoices/*" element={<InvoiceRoutes />} />
                
                {/* Legacy direct routes - CustomerList'ten gelen linkler için */}
                <Route path="new-customer" element={<NewCustomer />} />
                <Route path="transactions-list" element={<TransactionsList />} />
                <Route path="transactions/:customerId" element={<TransactionsList />} />
                <Route path="purchase-orders" element={<PurchaseOrders />} />
                <Route path="uyarilar" element={<Uyarilar />} />
                <Route path="sales-invoice/:customerId" element={<SalesInvoice />} />
                <Route path="debt-statement/:customerId" element={<DebtStatement />} />
                <Route path="receivable-statement/:customerId" element={<ReceivableStatement />} />
                <Route path="new-service/:customerId" element={<NewService />} />
                
                {/* Purchase Routes - SMS and Subscription */}
                <Route path="sms-purchase" element={<SmsPurchase />} />
                <Route path="subscription-purchase" element={<SubscriptionPurchase />} />
                
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Route>
            </Routes>
    );
};

export default MainRoutes;
